import {
  //SET_PLAYER_EDITING_DATA,
  SET_TABLE_SELECT_CELL,
  SET_FIND_ALL_INPUT,
  SET_FIND_ALL_TARGET_DATA,
  SET_FIND_ALL_SELECT_ROW_COL,
  INIT_DATA,
  SET_FIND_ALL_SHOW_REPLACE,
  SET_FIND_AND_REPLACE_SELECT_ROW_COL,
  SET_FIND_AND_REPLACE_SENTENCE,
  SET_FIND_AND_REPLACE_DATA, 
} from "./types";

import TimeUtils from "../helper/TimeUtils";

/**
 * 調整row內容
 * @param playerEditingData 現有資料
 * @param changeArray 使用者調整內容
 * */
export const afterFindReplaceChange =
  (playerEditingData, changeArray) => (dispatch) => {
    const rowIndex = changeArray[0];
    const key = changeArray[1];

    let newplayerEditingData = playerEditingData;

     newplayerEditingData[rowIndex][key] = changeArray[3];

    // let editRow = NewplayerEditingData[rowIndex];
    // if(`${key}` === 'SubtitleCaption'){
    //     editRow['SubtitleCaption'] = changeArray[3];
    // }

    // console.log(`update playerEditingData  ${JSON.stringify(newplayerEditingData)}`);

    //更新table顯示
    dispatch({
      type: INIT_DATA,
      payload: newplayerEditingData,
    });

    //更新
  };
 
export const setFindAllSelectRowCol = (result) => (dispatch) => {
  dispatch({
    type: SET_FIND_ALL_SELECT_ROW_COL,
    payload: result,
  });
};

/**
 * 設定 isShowFindAllViewInput
 * */
export const setIsShowFindAllViewInput = (result) => (dispatch) => {
  dispatch({
    type: SET_FIND_ALL_INPUT,
    payload: result,
  });
};

/**
 * 顯示字取代
 * */
export const setIsShowFindAllViewReplace = (result) => (dispatch) => {
  dispatch({
    type: SET_FIND_ALL_SHOW_REPLACE,
    payload: result,
  });

  //關閉視窗
  if (result === false) {
    //取消位置
    dispatch({
      type: SET_FIND_AND_REPLACE_SELECT_ROW_COL,
      payload: null,
    });

    //設定要顯示的句子
    dispatch({
      type: SET_FIND_AND_REPLACE_SENTENCE,
      payload: "",
    });

    //清空搜尋到的資料
    dispatch({
      type: SET_FIND_AND_REPLACE_DATA,
      payload: [],
    });
  }
};

/**
 * Find All 功能
 * @param tableData 標格資料
 * @param targetString 目標字
 * @param isSubtitle 是否為字幕
 * @param isMemo 是否為註解
 * @param isSource 是否資源
 * @param isCaseSensitivity 是否為大小寫敏感
 * */
export const findAllToSearch =
  (
    tableData,
    qTargetString,
    isSubtitle,
    isMemo,
    isCaseSensitivity,
    isSource,
    tableColMapping
  ) =>
  (dispatch) => {
    let newData = [];
    let targetString = qTargetString;

    tableData.forEach(function (obj, index) {
      let Memo = obj.Memo;
      let SubtitleCaption = obj.SubtitleCaption;
      let Source = obj.Source;

      if (isCaseSensitivity === true) {
        /** 大小寫要分開 不能混著判斷*/
        // console.log(`大小寫姳幹`)
      } else {
        /** 大小寫沒差*/
        // console.log(`大小寫沒差`)
        targetString = targetString.toLowerCase();
        SubtitleCaption = obj.SubtitleCaption.toLowerCase();
        Memo = Memo.toLowerCase();
        Source = Source.toLowerCase();
      }
      // console.log(`SubtitleCaption ${SubtitleCaption}
      // targetString ${targetString}
      // Memo ${Memo}`)

      if (isSubtitle === true) {
        if (SubtitleCaption.includes(targetString)) {
          //console.log(`SubtitleCaption ${index}`);
          newData.push({
            targetTitle: SubtitleCaption,
            type: "SubtitleCaption",
            rowIndex: index,
          });
        }
      }

      if (isMemo === true) {
        if (Memo.includes(targetString)) {
          // console.log(`Memo ${index}`);
          newData.push({ targetTitle: Memo, type: "Memo", rowIndex: index });
        }
      }

      if (isSource === true) {
        if (Source.includes(targetString)) {
          // console.log(`Source ${index}`);
          newData.push({
            targetTitle: Source,
            type: "Source",
            rowIndex: index,
          });
        }
      }
    });

    if (newData.length !== 0) {
      dispatch({
        type: SET_FIND_ALL_SELECT_ROW_COL,
        payload: [
          newData[0]["rowIndex"],
          tableColMapping[`${newData[0]["type"]}`],
        ],
      });

      dispatch({
        type: SET_FIND_ALL_TARGET_DATA,
        payload: newData,
      });
    }
  };

/**
 * Find And Replace 功能 搜尋字幕
 * @param moveType 前或後移動
 * @param tableData 標格資料
 * @param targetString 目標字
 * @param tableColMapping 是否為字幕
 * */
export const findAndReplaceSearch =
  (moveType, tableData, targetString, tableColMapping) => (dispatch) => {
    let newData = [];

    tableData.forEach(function (obj, index) {
      let { SubtitleCaption } = obj;

      if (SubtitleCaption.includes(targetString)) {
        newData.push({
          targetTitle: SubtitleCaption,
          type: "SubtitleCaption",
          rowIndex: index,
        });
      }
    });

    return newData;
  };

/**
 * Find And Replace row移動
 * @param moveType 前或後移動 0:後退 1:前進
 * @param replaceArray 尋找結果
 * @param findAndReplaceSelectRowCol 最後的紀錄
 * */
export const findAndReplaceMove =
  (moveType, replaceArray, findAndReplaceSelectRowCol, tableColMapping) =>
  (dispatch) => {
    // console.log(`findAndReplaceMove ${JSON.stringify({moveType,replaceArray,findAndReplaceSelectRowCol,tableColMapping})}`);

    let locationArray = [];
    let targetTitleArray = [];

    replaceArray.forEach(function (obj, index) {
      locationArray.push([obj["rowIndex"], tableColMapping[`${obj["type"]}`]]);

      targetTitleArray.push(obj["targetTitle"]);
    });

    let targetLocation = [];
    let tableMoveRow = 0;
    let sentence = "";
    if (findAndReplaceSelectRowCol === null) {
      let LocationOnj = locationArray[0];

      targetLocation = LocationOnj;
      tableMoveRow = LocationOnj[0];
      sentence = targetTitleArray[0];
    } else {
      const nowRow = findAndReplaceSelectRowCol[0];

     // console.log(`findAndReplaceMove ${moveType} ${nowRow}`);

      if (moveType === 1) {
        for (let i = 0; i < locationArray.length; i++) {
          let LocationOnj = locationArray[i];

          //取下一個
          if (LocationOnj[0] > nowRow) {
            targetLocation = locationArray[i];
            sentence = targetTitleArray[i];
            break;
          }

          if (i === locationArray.length - 1) {
            targetLocation = locationArray[0];
            sentence = targetTitleArray[0];
            break;
          }
        }
      } else if (moveType === 0) {
        for (let i = locationArray.length - 1; i >= 0; i--) {
          let LocationOnj = locationArray[i];

          //取上一個
          if (LocationOnj[0] < nowRow) {
            targetLocation = locationArray[i];
            sentence = targetTitleArray[i];
            break;
          }

          if (i === 0) {
            targetLocation = locationArray[locationArray.length - 1];
            sentence = targetTitleArray[locationArray.length - 1];
            break;
          }
        }
      }

      // console.log(
      //   `findAndReplaceMove 2 ${targetLocation} ${locationArray.length - 1}`
      // );
      // console.log(
      //   `findAndReplaceMove --------------------------------------------------`
      // );

      tableMoveRow = targetLocation[0];
    }

    //還沒移動過，先移動到第一個
    dispatch({
      type: SET_FIND_ALL_SELECT_ROW_COL,
      payload: targetLocation,
    });

    //設定目前顯示的位置
    dispatch({
      type: SET_FIND_AND_REPLACE_SELECT_ROW_COL,
      payload: targetLocation,
    });

    //table 位移
    dispatch({
      type: SET_TABLE_SELECT_CELL,
      payload: tableMoveRow,
    });

    //設定要顯示的句子
    dispatch({
      type: SET_FIND_AND_REPLACE_SENTENCE,
      payload: sentence,
    });

    return tableMoveRow;
    // console.log(sentence);
  };

//更新左側的搜尋結果
export const setFindAndReplaceSentence = (sentence) => (dispatch) => {
  //設定要顯示的句子
  dispatch({
    type: SET_FIND_AND_REPLACE_SENTENCE,
    payload: sentence,
  });
};



// WEBPACK FOOTER //
// ./src/actions/transOperation_find_Actions.js